import axios from 'axios'
import { PAGES, SERVICES } from '../constants'
import atelier from '../models/atelier'
import bricotheque from '../models/bricotheque'
import collecterie from '../models/collecterie'
import defaultModel from '../models/default'
import director from '../models/director'
import event from '../models/event'
import figure from '../models/figure'
import history from '../models/history'
import image from '../models/image'
import mission from '../models/mission'
import page from '../models/page'
import partenaire from '../models/partenaire.js'
import place from '../models/place'
import pole from '../models/pole'
import poste from '../models/poste'
import rapport from '../models/rapport'
import remark from '../models/remark'

const API = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL,
})

const getService = async (serviceName, model, { categoryId, limit, slug, pageNumber } = {}) => {
	const category = (categoryId && `&categories=${categoryId}`) || ''
	slug = (slug && `&slug=${slug}`) || ''
	limit = limit || 100
	const pageN = (pageNumber && `&page=${pageNumber}`) || ''

	const url = `${serviceName}?_embed&per_page=${limit}&acf_format=standard${category}${slug}${pageN}`

	const response = await API.get(url)
	const mapModel = model || page

	return mapModel(response.data, response.headers)
}

const putService = async (data) => {
	await API.put('send', data)
}

const getDairy = async () => await getService(PAGES.DAIRY)
const getHistory = async () => await getService(PAGES.HISTORY)
const getHistories = async () => await getService(SERVICES.HISTORY, history)
const getReferenceTeam = async () => await getService(PAGES.REFERENCE_TEAM)
const getEmploymentSupport = async () => await getService(PAGES.EMPLOYMENT_SUPPORT)
const getProjects = async () => await getService(PAGES.PROJECTS)
const getGiftObject = async () => await getService(PAGES.GIFT_OBJECT)
const getShop = async () => await getService(PAGES.SHOP)
const getRecoveryWorks = async () => await getService(PAGES.RECOVERY_WORKSHOP)
const getArtCraft = async () => await getService(PAGES.ART_CRAFT)
const getBenefit = async () => await getService(PAGES.BENEFIT)
const getDiy = async () => await getService(PAGES.DIY)
const getContact = async () => await getService(PAGES.CONTACT)
const getActivityReport = async () => await getService(PAGES.ACTIVITY_REPORT)
const getRecruitment = async () => await getService(PAGES.RECRUITMENT)
const getBecomeVolunteer = async () => await getService(PAGES.BECOME_VOLUNTEER)
const getPartner = async () => await getService(PAGES.PARTNER)
const getPlaces = async () => await getService(SERVICES.PLACES, place)

const getEvents = async (typeEvent, nPage, numberPerPage) => {
	const postsPerPage = numberPerPage || 8

	const url = `events?time=${typeEvent}&npage=${nPage}&total=${postsPerPage}`

	const response = await API.get(url)
	return event(response.data, response.headers)
}

const getImages = async (media) => await getService(SERVICES.IMAGES, image, { media })
const getFigures = async (categoryId) => await getService(SERVICES.FIGURES, figure, { categoryId })
const getMissions = async () => await getService(SERVICES.MISSIONS, mission)
const getCollecterie = async () => await getService(SERVICES.COLLECTERIE, collecterie)
const getPoles = async () => await getService(SERVICES.POLE, pole)
const getDirectors = async () => await getService(SERVICES.DIRECTOR, director)
const getDefaults = async (serviceName, pageNumber, limit) =>
	await getService(serviceName, defaultModel, { pageNumber, limit })
const getRemarks = async (categoryId, limit) =>
	await getService(SERVICES.REMARK, remark, { categoryId, limit })
const getDefaultDetails = async (serviceName, slug) =>
	await getService(serviceName, defaultModel, { slug })
const getPartenaires = async () => await getService(SERVICES.PARTENAIRE, partenaire)
const getPostes = async (categoryId) => await getService(SERVICES.POSTE, poste, { categoryId })
const getRapports = async () => await getService(SERVICES.RAPPORT, rapport)
const getBricotheques = async () => await getService(SERVICES.BRICOTHEQUE, bricotheque)
const getLeftRights = async (serviceName) => await getService(serviceName, bricotheque)
const getAteliers = async (categoryId) =>
	await getService(SERVICES.ATELIER, atelier, { categoryId })

const sendMail = async (data) => await putService(data)

const useAxios = () => {
	return {
		getDairy,
		getHistory,
		getHistories,
		getReferenceTeam,
		getEmploymentSupport,
		getProjects,
		getGiftObject,
		getShop,
		getRecoveryWorks,
		getArtCraft,
		getBenefit,
		getDiy,
		getContact,
		getActivityReport,
		getRecruitment,
		getBecomeVolunteer,
		getPartner,
		getPlaces,
		getEvents,
		getImages,
		getFigures,
		getMissions,
		getCollecterie,
		getPoles,
		getDirectors,
		getDefaults,
		getRemarks,
		getDefaultDetails,
		getPartenaires,
		getPostes,
		getRapports,
		getBricotheques,
		getLeftRights,
		getAteliers,
		sendMail,
	}
}

export default useAxios
